import {
  Component,
  OnInit,
  HostBinding,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  ComponentRef,
  ComponentFactoryResolver,
  ChangeDetectorRef
} from '@angular/core';
import {
  slideToRight,
  slideShow
} from '../../../shared/animations.collections';
import { CreateEventService } from '../../shared/createevent.listener';
import { PersonInfoComponent } from '../../../account/person-info/person-info.component';
import { SalesDocComponent } from '../../../account/sales-doc/sales-doc.component';
import { DigitalWalletComponent } from '../../../account/digital-wallet/digital-wallet.component';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ShoppingCartService } from '../../../services/shopping-cart.service';
import { UserInfo, AliasLoginInfo, AccountContact, AccountSearchListModel } from '../../../models/Profile-view.model';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MyAccountService } from '../../../services/myAccount.service';
import { CompleterData, CompleterService, CompleterItem, CompleterCmp } from 'ng2-completer';
import { NgProgress } from 'ngx-progressbar';
import { CommonService } from '../../../services/common.service';
import { CurrentUserModel, CompanyInfoViewModel } from '../../../models/account-ledger.model';
import { ManageSubscriptionsComponent } from '../../../manage-subscriptions/manage-subscriptions.component';
import { switchMap, debounceTime, tap, finalize } from 'rxjs/operators';
import { Observable, Subject, of } from 'rxjs';
// import { AliasLoginComponent } from '../user/alias-login/alias-login.component';
import { accountTemplate } from '../../../cms/models/cms.model';
import { AuthService } from '../../../services/auth.service';
import { DeleteSubscriptionsComponent } from '../../../account/subscriptions/subscriptions.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgProgressService } from '../../../services/ngProgress.service';

declare var $: any;

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
  animations: [slideToRight('100%'), slideShow]
})
export class UserComponent implements OnInit, OnDestroy {
  @ViewChild('sidecontainer', { read: ViewContainerRef })
  sidecontainer: ViewContainerRef;
  dsContactList: CompleterData;
  contactData: Array<Object> = new Array<Object>();

  component: ComponentRef<any>;
  showStatus = true;
  closeResult: string;
  tempAccountId: string;
  accountId: string;
  companyName: string;
  contactName: string;
  currentUserModel: CurrentUserModel;
  companyInfo: CompanyInfoViewModel;
  userInfo: UserInfo;
  dsAccountList: CompleterData;

  aliasLoginInfo: AliasLoginInfo = <AliasLoginInfo>{};
  contactList: Array<AccountContact> = new Array<AccountContact>();

  loginUserList: string[] = [];
  modalRef: NgbModalRef;
  hasAliasLogin = false;
  initialValue: string;
  public isOpen = false;
  txtAccountSearch: string;
  isStaffAccount = false;
  aliasLoginRef = null;
  loadContent = true;
  @ViewChild('loginListDropdown') private loginListDropdown: CompleterCmp;
  /**
   * NOTE :
   * personal
   * sales
   * subscriptions
   * we don not need use the eventSergvice anymore
   */

  createSub$;
  @HostBinding('@slideToRight') ani;
  constructor(
    private resolver: ComponentFactoryResolver,
    private changeDetector: ChangeDetectorRef,
    private pageService: CreateEventService,
    private modalService: NgbModal,
    private shoppingCartService: ShoppingCartService,
    private accountService: MyAccountService,
    private completerService: CompleterService,
    private ngProgress: NgProgressService,
    private commonService: CommonService,
    public dialog: MatDialog,
    private authService: AuthService

  ) {
    this.dsAccountList = completerService.remote('api/MyAccount/GetAccountByNameOrId?accountNameOrId=', 'shortName', 'shortName');
  }

  logout() {
    window.location.href = '/account/logout';
  }

  openPersonalInformation(event: any) {
    event.stopPropagation();
    this.sidecontainer.clear();
    this.showStatus = false;
    this.changeDetector.detectChanges();

    const comfactory = this.resolver.resolveComponentFactory(
      PersonInfoComponent
    );

    this.component = this.sidecontainer.createComponent(comfactory);
  }

  openPersonalSubscription(event: any) {
    event.stopPropagation();
    this.sidecontainer.clear();
    this.showStatus = false;
    this.changeDetector.detectChanges();

    const comfactory = this.resolver.resolveComponentFactory(
      DeleteSubscriptionsComponent
    );

    this.component = this.sidecontainer.createComponent(comfactory);
  }

  openSales(event: any) {
    event.stopPropagation();
    this.sidecontainer.clear();
    this.showStatus = false;
    this.changeDetector.detectChanges();
    const comfactory = this.resolver.resolveComponentFactory(SalesDocComponent);
    this.component = this.sidecontainer.createComponent(comfactory);
  }

  openWallet(event: any) {
    this.sidecontainer.clear();
    this.showStatus = false;
    const comfactory = this.resolver.resolveComponentFactory(DigitalWalletComponent);
    this.component = this.sidecontainer.createComponent(comfactory);
  }

  openSubscription(event: any) {
    this.sidecontainer.clear();
    this.showStatus = false;
    const comfactory = this.resolver.resolveComponentFactory(ManageSubscriptionsComponent);
    this.component = this.sidecontainer.createComponent(comfactory);

  }

  open(content, event) {
    if (this.hasAliasLogin) {
      this.accountService.BackToMyLogin().subscribe((res: any) => {
        if (res.result === true) {
          this.shoppingCartService.monitorAliasLogin(this.hasAliasLogin);
          this.shoppingCartService.monitorAliasDashboard(this.hasAliasLogin);
          return;
        }
      });
    } else {
      this.modalRef = this.modalService.open(content, { centered: true, backdrop: 'static', keyboard: false });
      this.modalRef.result.then(
        result => {
          this.closeResult = `Closed with: ${result}`;
        },
        reason => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    this.hasAliasLogin = !this.hasAliasLogin;
  }

  clickAliasLogin(event) {
    event.stopPropagation();
  }


  openAliasLogin(event, aliasAgain) {

    if (!this.hasAliasLogin || aliasAgain) {
      const dialogRef = this.dialog.open(AliasLoginComponent, {
        panelClass: 'mat-dialog-wrapper',
        width: '450px',
        hasBackdrop: true,
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(res => {
        if (!res) { this.hasAliasLogin = false; }
      });
    } else {
      this.accountService.BackToMyLogin().subscribe((res: any) => {
        if (res.result === true) {
          this.updateUserInfo();
          this.shoppingCartService.monitorAliasLogin(this.hasAliasLogin);
          this.shoppingCartService.monitorAliasDashboard(this.hasAliasLogin);
          this.loadContent = false;
          this.commonService.implementToast('Logout successful', 'Success');
          window.location.reload();
        }
      });


    }

    this.hasAliasLogin = !this.hasAliasLogin;

  }



  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  unCheckAlias() {
    this.hasAliasLogin = false;
  }

  onAccountIdChange = () => {
    this.contactData = [];
  }

  onAccountSelected = (item: CompleterItem) => {
    if (item != null && item.originalObject != null) {
      this.accountId = item.originalObject.accountId;
      this.companyName = item.originalObject.accountName + '-' + item.originalObject.accountId;
      // this.contactData = new Array<Object>();
      // this.dsContactList = this.completerService.local(this.contactData, 'name', 'name');
      this.getContactList();
    }
  }

  aliasLogin() {
    this.aliasLoginInfo.loginName = this.contactName;
    this.aliasLoginInfo.accountId = this.accountId;
    if (!this.aliasLoginInfo || !this.aliasLoginInfo.accountId || !this.aliasLoginInfo.loginName) {
      // debugger;
      // this.commonService.showValidator('#textContactName', 'Please select an user', 'left', 'error');
      this.commonService.implementToast('Please select an user', 'Error');
      return;
    }

    this.ngProgress.start();
    this.accountService.AliasLogin(this.aliasLoginInfo).subscribe((res: any) => {
      if (res.result === true) {
        this.updateUserInfo();
        this.hasAliasLogin = true;
        // this.commonService.showValidator('.btn-aliasLogin', 'Login successful', 'left', 'success');
        this.commonService.implementToast('Login successful', 'Success');
        this.ngProgress.done();

        setTimeout(() => {
          this.shoppingCartService.monitorAliasLogin(this.hasAliasLogin);
          this.shoppingCartService.monitorAliasDashboard(this.hasAliasLogin);
          this.modalRef.close();
        }, 200);

      }
    });
  }

  getContactList() {
    this.accountService.GetAccountUserList(this.accountId).subscribe((result: Array<AccountContact>) => {
      this.contactData = new Array<Object>();
      this.dsContactList = this.completerService.local(this.contactData, 'name', 'name');

      if (result != null && result.length > 0) {
        this.contactList = result;
        this.contactData = this.contactList.map((val) => ({ name: val.out_login_id, value: val.out_login_id }));
        this.dsContactList = null;
        setTimeout(() => {
          this.dsContactList = this.completerService.local(this.contactData, 'name', 'name');
          this.loginListDropdown.focus();
        }, 100);


      }

    });
  }


  ngOnInit() {

    this.pageService.destory.subscribe(value => {

      this.sidecontainer.clear();
      setTimeout(() => {
        this.showStatus = true;
      }, 350);
    });

    this.updateUserInfo();
  }

  updateUserInfo(): void {
    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.authService.currentUserModel = res;
      this.currentUserModel = res;
      this.companyName = res.companyName + '-' + res.accountId;
      this.hasAliasLogin = res.isImpersonated;
      this.contactName = res.loginId;
      this.tempAccountId = '';

      if (res.isStaffAccount || res.isImpersonated) {
        this.isStaffAccount = true;
      } else {
        this.isStaffAccount = false;
      }

    },
      (error: any) => {
        console.error(error);
      });

  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy(): void { }
}


@Component({
  selector: 'alias-login',
  templateUrl: './alias-login.component.html',
  styleUrls: ['./alias-login.component.css']
})

export class AliasLoginComponent implements OnInit {
  aliasFromGroup: FormGroup;
  isLoading = false;
  accountList: AccountSearchListModel[];
  selectedAccount: AccountSearchListModel;
  txtAccountName1 = '';
  contactList: Array<AccountContact> = new Array<AccountContact>();
  selectedUser: string;
  aliasLoginInfo: AliasLoginInfo = <AliasLoginInfo>{};
  user: any;
  loadContent = true;
  peopleInput$ = new Subject<string>();
  loginStatus = true;

  constructor(
    public dialogRef: MatDialogRef<AliasLoginComponent>,
    private accountService: MyAccountService,
    private formBuilder: FormBuilder,
    private shoppingCartService: ShoppingCartService,
    private commonService: CommonService,
    private ngProgress: NgProgressService
  ) {

  }

  ngOnInit() {
    this.aliasFromGroup = this.formBuilder.group({
      txtAccountSearch: new FormControl(''),
      txtLoginId: new FormControl(''),
      txtLogin: new FormControl(''),
      txtAccountName: new FormControl('')
    });

    this.loadAccount();
  }

  accountSelected() {
    if (this.aliasFromGroup.get('txtAccountSearch').value) {
      this.aliasFromGroup
        .get('txtAccountName')
        .setValue(this.accountList.filter(x => x.accountId === this.aliasFromGroup.get('txtAccountSearch').value)[0].accountId);

      this.accountService.GetAccountUserList(this.aliasFromGroup.get('txtAccountSearch').value).subscribe(
        (result: Array<AccountContact>) => {
          this.contactList = result.filter(x => x.out_login_id !== '');
          this.selectedUser = this.contactList[0].out_login_id;
          this.aliasFromGroup.get('txtLogin').setValue(this.contactList[0].out_login_id);
        });
    } else {
      this.aliasFromGroup.get('txtAccountName').setValue('');
      this.aliasFromGroup.get('txtLogin').setValue('');
      this.selectedUser = '';
      this.contactList = [];
    }
  }

  loadAccount() {
    this.peopleInput$
      .pipe(
        debounceTime(300),
        tap(() => {
          this.isLoading = true;
        }),
        switchMap(value => value && value.length > 2 ? this.accountService.getaccountSearchList(value) : of([])
          .pipe(
            finalize(() => {
              this.isLoading = false;
            }),
          )
        )
      )
      .subscribe((accountSearchResults:any) => { this.accountList = accountSearchResults; this.isLoading = false; });
  }

  customSearchFn(term: string, item: AccountContact): any {
    term = term.toLowerCase();
    return item.out_login_id.toLowerCase().indexOf(term) > -1;
  }

  cancelAliasLogin(): void {
    this.dialogRef.close(false);
  }

  contactSelected(): void {
    this.aliasFromGroup.get('txtLogin').setValue(this.selectedUser);
  }

  aliasLogin(): void {
    this.aliasLoginInfo.loginName = this.aliasFromGroup.get('txtLogin').value;
    this.aliasLoginInfo.accountId = this.aliasFromGroup.get('txtAccountSearch').value;
    if (!this.aliasLoginInfo || !this.aliasLoginInfo.accountId || !this.aliasLoginInfo.loginName || !this.selectedUser) {
      // this.commonService.showValidator('#txtAccountSearch', 'Please select an account and user', 'right', 'error');
      this.commonService.implementToast('Please select an account and user', 'Error');
      return;
    }

    this.ngProgress.start();
    this.accountService.AliasLogin(this.aliasLoginInfo).subscribe((res: any) => {
      if (res.result === true) {
        this.loginStatus = false;
        // this.commonService.showValidator('.btn-aliasLogin', 'Login successful', 'right', 'success');
        this.commonService.implementToast('Login successful', 'Success');
        this.loadContent = false;
        setTimeout(() => {
          window.location.reload();
        }, 200);
        this.ngProgress.done();

        setTimeout(() => {
          this.shoppingCartService.monitorAliasLogin(true);
          this.shoppingCartService.monitorAliasDashboard(true);
          this.dialogRef.close(true);
        }, 400);

      }
    });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }
}
